<template>
  <FormGroup
    :label="peopleOptions.label"
    :class="peopleOptions.className"
    :data-test-id="dataTestId + '__label'"
  >
    <TextField
      ref="textField"
      :id="id"
      :model-value="modelValue"
      :icon="PeopleIcon"
      :placeholder="peopleOptions.placeholder"
      :errors="errors"
      :is-marked-as-invalid="errors.length > 0"
      :data-test-id="dataTestId"
      :min="0"
      type="number"
      inputmode="numeric"
      pattern="\d*"
      @update:modelValue="$emit('update:modelValue', $event)"
      @click="$emit('click')"
      @change="$emit('change')"
    />
  </FormGroup>
</template>

<script>
import PeopleIcon from '@tagvenue/icons/24/line/users/users-03.svg';
import { markRaw } from 'vue';
import { mapState } from 'vuex';

import FormGroup from '@/components/Ui/Forms/FormGroup.vue';
import TextField from '@/components/Ui/Forms/TextField.vue';
import htmlProps from '@/components/Ui/htmlProps.js';
import inputHandlers from '@/services/inputHandlers/index.js';

export default {
  name: 'PeopleField',
  emits: ['update:modelValue', 'click', 'change'],
  mixins: [htmlProps],
  components: { TextField, FormGroup },

  props: {
    modelValue: {
      type: [Number, String],
      required: true,
    },
    errors: {
      type: Array,
      required: true,
    },
    maxCapacity: {
      type: Number,
      required: true,
    },
    id: {
      type: String,
      default: 'people',
    },
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      PeopleIcon: markRaw(PeopleIcon),
    };
  },

  computed: {
    ...mapState({
      searchedEventType: state => state.user.searchedEventType,
    }),
    peopleOptions() {
      const people = parseInt(this.modelValue, 10);
      const isOverCapacity = people > this.maxCapacity;

      let className = '';
      let capacitySuffix = '';
      if (isOverCapacity) {
        capacitySuffix = `(max ${this.maxCapacity})`;
        className = 'people-capacity-warning';
      }

      let label = '';
      if (this.title) {
        label = this.title;
      } else {
        label = `${this?.$store?.getters?.eventTypeSpecificCopy?.people} ${capacitySuffix}`;
      }

      return {
        placeholder: `Max ${this.maxCapacity}`,
        label,
        className,
      };
    },
  },

  mounted() {
    inputHandlers.number(this.$refs.textField.$el.querySelector('input'));
  },
};
</script>

<style lang="scss" scoped>
@use "@sass/design-system/variables" as ds-variables;

.people-capacity-warning :deep(.ds-form-label) {
  color: ds-variables.$yellow;
}
.people-capacity-warning :deep(input) {
  border-color: ds-variables.$yellow;
}
</style>
